(function() {
    'use strict';

    // ===== 1. Add Social Media Links to Footer =====
    function addSocialLinks() {
        if (document.querySelector('#xidu-social-links')) return;

        var footer = document.querySelector('.footer, .site-footer, footer');
        if (!footer) return;

        var socialContainer = document.createElement('div');
        socialContainer.id = 'xidu-social-links';
        socialContainer.style.cssText = 'display:flex;justify-content:center;gap:16px;padding:20px 0;border-top:1px solid rgba(201,169,110,0.2);margin-top:16px;';

        var socials = [
            { name: 'Instagram', url: 'https://www.instagram.com/xidudiy', icon: 'M12 2.16c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.43.36 1.06.41 2.23.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.43.16-1.06.36-2.23.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.41-.56-.22-.96-.48-1.38-.9-.42-.42-.68-.82-.9-1.38-.16-.43-.36-1.06-.41-2.23-.06-1.27-.07-1.65-.07-4.85s.01-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.43-.16 1.06-.36 2.23-.41 1.27-.06 1.65-.07 4.85-.07M12 0C8.74 0 8.33.01 7.05.07 5.78.13 4.9.33 4.14.63c-.79.31-1.46.72-2.13 1.38C1.35 2.68.94 3.35.63 4.14.33 4.9.13 5.78.07 7.05.01 8.33 0 8.74 0 12s.01 3.67.07 4.95c.06 1.27.26 2.15.56 2.91.31.79.72 1.46 1.38 2.13.67.66 1.34 1.07 2.13 1.38.76.3 1.64.5 2.91.56C8.33 23.99 8.74 24 12 24s3.67-.01 4.95-.07c1.27-.06 2.15-.26 2.91-.56.79-.31 1.46-.72 2.13-1.38.66-.67 1.07-1.34 1.38-2.13.3-.76.5-1.64.56-2.91.06-1.28.07-1.69.07-4.95s-.01-3.67-.07-4.95c-.06-1.27-.26-2.15-.56-2.91-.31-.79-.72-1.46-1.38-2.13C21.32 1.35 20.65.94 19.86.63 19.1.33 18.22.13 16.95.07 15.67.01 15.26 0 12 0z M12 5.84c-3.4 0-6.16 2.76-6.16 6.16s2.76 6.16 6.16 6.16 6.16-2.76 6.16-6.16S15.4 5.84 12 5.84zm0 10.16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z M18.41 4.15c-.8 0-1.44.65-1.44 1.44s.65 1.44 1.44 1.44 1.44-.65 1.44-1.44-.65-1.44-1.44-1.44z' },
            { name: 'TikTok', url: 'https://www.tiktok.com/@xidudiy', icon: 'M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.84-.1z' },
            { name: 'Pinterest', url: 'https://www.pinterest.com/xidudiy', icon: 'M12 0C5.37 0 0 5.37 0 12c0 5.08 3.16 9.43 7.63 11.18-.11-.95-.2-2.4.04-3.44.22-.93 1.4-5.94 1.4-5.94s-.36-.72-.36-1.78c0-1.66.97-2.9 2.17-2.9 1.02 0 1.51.77 1.51 1.69 0 1.03-.65 2.56-1 3.99-.29 1.19.6 2.16 1.77 2.16 2.13 0 3.76-2.25 3.76-5.49 0-2.87-2.06-4.88-5.01-4.88-3.41 0-5.42 2.56-5.42 5.21 0 1.03.4 2.14.89 2.74.1.12.11.22.08.34l-.33 1.34c-.05.22-.17.27-.4.16-1.49-.69-2.42-2.87-2.42-4.62 0-3.76 2.73-7.21 7.87-7.21 4.13 0 7.34 2.94 7.34 6.88 0 4.1-2.59 7.4-6.18 7.4-1.21 0-2.34-.63-2.73-1.37l-.74 2.83c-.27 1.03-1 2.33-1.49 3.12C9.57 23.83 10.77 24 12 24c6.63 0 12-5.37 12-12S18.63 0 12 0z' }
        ];

        socials.forEach(function(s) {
            var link = document.createElement('a');
            link.href = s.url;
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
            link.setAttribute('aria-label', s.name);
            link.style.cssText = 'display:flex;align-items:center;justify-content:center;width:36px;height:36px;border-radius:50%;background:rgba(201,169,110,0.15);transition:all 0.3s ease;color:#c9a96e;';
            link.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="' + s.icon + '"/></svg>';

            link.addEventListener('mouseenter', function() {
                link.style.background = 'rgba(201,169,110,0.3)';
                link.style.transform = 'translateY(-2px)';
            });
            link.addEventListener('mouseleave', function() {
                link.style.background = 'rgba(201,169,110,0.15)';
                link.style.transform = 'translateY(0)';
            });

            socialContainer.appendChild(link);
        });

        // Insert before the copyright/utilities section
        var insertBefore = footer.querySelector('.footer__bottom, .footer-bottom, .copyright, .footer__copyright, .utilities');
        if (insertBefore) {
            insertBefore.parentNode.insertBefore(socialContainer, insertBefore);
        } else {
            footer.appendChild(socialContainer);
        }
    }

    // ===== 2. Add Brand Story Section to Homepage =====
    function addBrandStory() {
        if (window.location.pathname !== '/') return;
        if (document.querySelector('#xidu-brand-story')) return;

        var mainContent = document.querySelector('#MainContent, main, .main-content');
        if (!mainContent) return;

        var brandStory = document.createElement('section');
        brandStory.id = 'xidu-brand-story';
        brandStory.style.cssText = 'padding:60px 20px;text-align:center;max-width:800px;margin:0 auto;';
        brandStory.innerHTML = [
            '<div style="margin-bottom:24px;">',
            '  <div style="display:inline-block;width:60px;height:2px;background:#c9a96e;margin-bottom:16px;"></div>',
            '  <h2 style="font-family:serif;font-size:2rem;color:#3a3530;margin-bottom:12px;letter-spacing:0.03em;">Our Story</h2>',
            '</div>',
            '<p style="font-size:1.05rem;line-height:1.8;color:#5a5550;max-width:600px;margin:0 auto 16px;">',
            '  XIDU DIY was born from a passion for crystals, music, and the stories they tell. ',
            '  Each piece is handcrafted with intention — whether it\'s a crystal bracelet tuned to your energy, ',
            '  or a music-inspired keepsake that captures a moment in time.',
            '</p>',
            '<p style="font-size:1.05rem;line-height:1.8;color:#5a5550;max-width:600px;margin:0 auto 24px;">',
            '  Our DIY Customizer lets you design your own bracelet, bead by bead, ',
            '  choosing from 39 crystal types with real-time preview. ',
            '  Every creation is unique — just like you.',
            '</p>',
            '<a href="/pages/diy-designer" style="display:inline-block;padding:12px 36px;background:linear-gradient(135deg,#c9a96e,#b8965a);color:#1a1410;font-weight:600;text-decoration:none;border-radius:4px;letter-spacing:0.08em;text-transform:uppercase;font-size:0.85rem;transition:all 0.3s ease;box-shadow:0 4px 20px rgba(201,169,110,0.3);">',
            '  Design Yours',
            '</a>'
        ].join('');

        // Insert after the first section (hero)
        var firstSection = mainContent.querySelector('.shopify-section');
        if (firstSection && firstSection.nextElementSibling) {
            mainContent.insertBefore(brandStory, firstSection.nextElementSibling);
        } else {
            mainContent.appendChild(brandStory);
        }
    }

    // ===== 3. Add Trust Badges to Product Pages =====
    function addTrustBadges() {
        if (window.location.pathname.indexOf('/products/') < 0) return;
        if (document.querySelector('#xidu-trust-badges')) return;

        var buyButtons = document.querySelector('.product-form__buttons, .shopify-payment-button, .product__buy-buttons, form[action*="/cart/add"]');
        if (!buyButtons) return;

        var badges = document.createElement('div');
        badges.id = 'xidu-trust-badges';
        badges.style.cssText = 'display:flex;flex-wrap:wrap;gap:12px;margin-top:16px;padding-top:16px;border-top:1px solid rgba(0,0,0,0.08);';

        var items = [
            { icon: 'M20 6L9 17l-5-5', text: 'Handmade with Love' },
            { icon: 'M12 2L4 7v6c0 5 3.5 9 8 10 4.5-1 8-5 8-10V7l-8-5z', text: 'Natural Crystals' },
            { icon: 'M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z M12 13a3 3 0 100-6 3 3 0 000 6z', text: 'Free Shipping over $30' },
            { icon: 'M9 11l3 3L22 4 M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11', text: 'Secure Checkout' }
        ];

        items.forEach(function(item) {
            var badge = document.createElement('div');
            badge.style.cssText = 'display:flex;align-items:center;gap:6px;font-size:0.78rem;color:#6a6560;';
            badge.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#c9a96e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="' + item.icon + '"/></svg><span>' + item.text + '</span>';
            badges.appendChild(badge);
        });

        buyButtons.parentNode.insertBefore(badges, buyButtons.nextSibling);
    }

    // ===== 4. Add Default Product Description =====
    function addDefaultDescription() {
        if (window.location.pathname.indexOf('/products/') < 0) return;

        var descContainer = document.querySelector('.product__description, .rte, .product-description, .product__info .description');
        if (!descContainer) return;
        if (descContainer.textContent.trim().length > 20) return; // Already has description
        if (document.querySelector('#xidu-default-desc')) return;

        var desc = document.createElement('div');
        desc.id = 'xidu-default-desc';
        desc.style.cssText = 'padding:16px 0;';
        desc.innerHTML = [
            '<p style="margin-bottom:12px;line-height:1.7;">Each piece is meticulously handcrafted using natural crystals and premium materials. Our jewelry is designed to be worn daily and cherished for years to come.</p>',
            '<ul style="list-style:none;padding:0;margin:0 0 12px;">',
            '  <li style="padding:4px 0;display:flex;align-items:center;gap:8px;"><span style="color:#c9a96e;">✦</span> Natural genuine crystals</li>',
            '  <li style="padding:4px 0;display:flex;align-items:center;gap:8px;"><span style="color:#c9a96e;">✦</span> Handmade with care</li>',
            '  <li style="padding:4px 0;display:flex;align-items:center;gap:8px;"><span style="color:#c9a96e;">✦</span> Adjustable sizing (18-20cm)</li>',
            '  <li style="padding:4px 0;display:flex;align-items:center;gap:8px;"><span style="color:#c9a96e;">✦</span> Free shipping on orders over $30</li>',
            '</ul>',
            '<p style="margin-top:12px;font-size:0.85rem;color:#8a8078;">Looking for something truly unique? <a href="/pages/diy-designer" style="color:#c9a96e;text-decoration:underline;">Design your own custom bracelet →</a></p>'
        ].join('');

        descContainer.appendChild(desc);
    }

    // ===== INIT =====
    function init() {
        addSocialLinks();
        addBrandStory();
        addTrustBadges();
        addDefaultDescription();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    // Re-run for AJAX navigation (but with guard)
    var initCount = 0;
    var observer = new MutationObserver(function() {
        if (initCount < 3) {
            initCount++;
            setTimeout(function() { init(); initCount--; }, 500);
        }
    });
    observer.observe(document.body, { childList: true, subtree: true });

})();